module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ded"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('i', [_vm._v("To Rolf Lassgård with great warmth, gratitude, and not a little admiration. He has told me so much about Wallander that I myself did not know.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c2914a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/henn_9781595585820_oeb_ded_r1.vue
// module id = 66
// module chunks = 0